import { useCallback, useState } from 'react';

export default function useToggle() {
  const [visible, setVisible] = useState(false);
  const toggle = useCallback(() => setVisible(!visible), [visible]);

  return [visible, toggle];
}
